/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для слайдера фильтра по цене
   */
  app.Filters.RangeFilterView = app.BaseFilterView.extend({
    template: '',
    events: {
      'change .js-filter-range-input': 'changeValue',
      'keyup .js-filter-range-input': 'changeLabelValue',
    },

    /**
     * @inheritDoc
     */
    initialize: function (data) {
      this.template = app.helpers.TemplateHelper.getTemplate('#range-filter-view');
      if (data.object && data.parent) {
        data.object.sign = app.currentCurrency.sign;
        var values = data.object.values;
        var sliderStep = this.model.get('slider_step');
        var maxValueWithSpaces = app.helpers.NumberHelper.addSpaceToFloatNumber(Number(values.max.value));
        data.parent.append(
          this.template({
            name: data.object.name,
            sign: data.object.sign,
            values: data.object.values,
            isMobile: app.isMobile,
            minValue: app.helpers.NumberHelper.addSpaceToFloatNumber(values.min.selected),
            maxValue: app.helpers.NumberHelper.addSpaceToFloatNumber(values.max.selected),
          })
        );
        this.setElement($('#' + data.object.name + '_filter'));
        this.$beginInput = this.$('.filter-range-begin-input');
        this.$endInput = this.$('.filter-range-end-input');
        this.$beginInput.attr('maxlength', maxValueWithSpaces.length);
        this.$endInput.attr('maxlength', maxValueWithSpaces.length);
        this.Slider = this.$('.slider_div');
        this.Slider.slider({
          range: true,
          step: sliderStep,
          min: values.min.value,
          max: values.max.value,
          values: [values.min.selected, values.max.selected],

          // вызываем кастомные события слайдера
          slide: function (event, ui) {
            this.render(ui);
          }.bind(this),
          change: function (event, ui) {
            this.model.set({
              minSelected: ui.values[0],
              maxSelected: ui.values[1]
            });
          }.bind(this),
          stop: function () {
            this.$endInput.trigger('change');
          }.bind(this)
        });
        this.setFontSize(values.min.selected, values.max.selected);
      }
    },

    /**
     * Обработка изменения значения в инпуте
     * @param {Event} e - событие изменения
     */
    changeValue: function (e) {
      var currentTarget = e.currentTarget;
      this.model.set(currentTarget.name, this.parseValue(currentTarget.value));
      this.sendChangeEvent(e);
      this.render();
    },

    /**
     * Изменяет значение в лэйбле инпута.
     * @param {Event|Object} event - событие ввода символа в инпут
     */
    changeLabelValue: function (event) {
      var $currentTarget = this.$(event.currentTarget);
      $currentTarget.prev().children('.js-label-value').text($currentTarget.val());
    },

    /**
     * Смена размера шрифта в зависимости от значения в инпуте.
     * @param {number} minRange - минимальное значение
     * @param {number} maxRange - максимальное значение
     */
    setFontSize: function (minRange, maxRange) {
      var $withRur = this.$('.with-rur');
      $withRur.removeClass('font-small');
      if (minRange > 999999 || maxRange > 999999) {
        $withRur.addClass('font-small');
      }
    },

    /**
     * @inheritDoc
     * @param {Object|undefined} ui - обьект со значениями слайдера
     * @returns {app.Filters.RangeFilterView}
     */
    render: function (ui) {
      if (typeof ui === 'undefined') {
        this.Slider.slider('values', [
          this.parseValue(this.$beginInput.val()),
          this.parseValue(this.$endInput.val())
        ]);
      } else {
        this.$beginInput.val(app.helpers.NumberHelper.addSpaceToFloatNumber(ui.values[0]));
        this.changeLabelValue({ currentTarget: this.$beginInput });
        this.$endInput.val(app.helpers.NumberHelper.addSpaceToFloatNumber(ui.values[1]));
        this.changeLabelValue({ currentTarget: this.$endInput });
      }
      return this;
    },

    /**
     * Убирает из строки все кроме чисел и точки.
     * @param value    Значение
     * @returns {*}
     */
    parseValue: function (value) {
      if (typeof value !== 'number') {
        value = value.replace(/[^\d.,]/g, '').replace(',', '.');
      }
      return value;
    },
  });
})(jQuery);

}.call(window));